import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import DFNotePin from "components/DFIcons/DFNotePin";
import NoteIcon from "@material-ui/icons/Note";
import CallIcon from "@material-ui/icons/Call";
import TextsmsOutlinedIcon from "@material-ui/icons/TextsmsOutlined";
import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import { useEffect, useState } from "react";
import { useGetOneSmsLog } from "utils/hooks/apiHooks/useGetOneSmsLog";
import useUserContext from "hooks/context-hooks/useUserContext";
import LogDetails from "components/LogDetails";
import { useGetOneCallLog } from "utils/hooks/apiHooks/useGetOneCallLog";
import { useGetOneChatWidgetLog } from "utils/hooks/apiHooks/useGetOneChatWidgetLog";
import NoteItemMenu from "./NoteItemMenu";
import useModal from "hooks/useModal";
import { useGetOneWebLog } from "utils/hooks/apiHooks/useGetOneWebLog";
type NoteItemProps = {
  content: string;
  isPinned: boolean;
  onUpdatePinnedStatus: () => void;
  backgroundColor?: string;
  type?: "ChatWidget" | "Note" | "CallLog" | "WebFormLog" | "SmsLog";
  logId?: string;
  username: string;
  date: string;
};
const LogTypeMap = {
  ChatWidget: "chat_widget",
  Note: "note",
  CallLog: "call_log",
  WebFormLog: "web_form_log",
  SmsLog: "sms_log",
} as const;

export default function PinnedItem({
  content,
  onUpdatePinnedStatus,
  backgroundColor,
  type,
  logId,
  username,
  date,
}: // date,
NoteItemProps) {
  const LogIcons = {
    ChatWidget: <TextsmsOutlinedIcon fontSize="small" />,
    SmsLog: <TextsmsOutlinedIcon fontSize="small" />,
    WebFormLog: <LanguageOutlinedIcon fontSize="small" />,
    Note: <NoteIcon />,
    CallLog: <CallIcon />,
  };

  const { data: smsData, loading: loadingSms } = useGetOneSmsLog(
    type === "SmsLog" ? logId : null
  );
  const { data: callData, loading: loadingCall } = useGetOneCallLog(
    type === "CallLog" ? logId : null
  );

  const { data: chatWidgetData, loading: loadingChat } = useGetOneChatWidgetLog(
    type === "ChatWidget" ? logId : null
  );

  const { data: webFormData, loading: loadingWebFormData } = useGetOneWebLog(
    type === "WebFormLog" ? logId : null
  );

  const loading = loadingCall || loadingSms;
  const singleData = {
    ChatWidget: chatWidgetData,
    SmsLog: smsData,
    WebFormLog: webFormData,
    Note: undefined as {},
    CallLog: callData,
  };

  const [open, setOpen] = useState<boolean>();
  const { user } = useUserContext();

  const [anchorEl, closeModal, openModal] = useModal("note_item_dropdown_menu");
  const handleClick = (event: any) => {
    openModal(event.currentTarget);
    event.stopPropagation();
  };

  return (
    <div
      style={{
        cursor: "pointer",
      }}
      onClick={(e) => {
        handleClick(e);
      }}
    >
      <div
        style={{
          background: backgroundColor || "#fdfd96",
          position: "relative",
          boxShadow: "-5px 5px 6px -1px rgba(0,0,0,0.35)",
          marginBottom: 5,
          fontFamily: "Arial, sans-serif",
        }}
      >
        <ListItem style={{ padding: 0, paddingLeft: 20, paddingTop: 5 }}>
          <ListItemIcon onClick={onUpdatePinnedStatus}>
            {LogIcons[type]}
          </ListItemIcon>
          <div style={{ width: "100%", marginRight: 10 }}>
            <ListItemText primary={<div>{content}</div>} />
          </div>
        </ListItem>
        <div
          style={{
            fontSize: 11,
            color: "gray",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            paddingRight: 30,
            paddingBottom: 4,
          }}
        >
          <p style={{ marginRight: 10 }}>
            {" "}
            {username} - {date}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "15px",
            height: "15px",
            transform: "rotate(-90deg) ",
          }}
        >
          <div
            style={{
              transform: "translateX(-10px) translateY(-20px) rotate(140deg) ",
            }}
          >
            <DFNotePin isPinned />
          </div>
        </div>
      </div>

      {!loading && singleData[type] && (
        //  @ts-ignore
        <LogDetails
          // upsertContactCallBack={()}
          // updateLogDetailsCallBack={({ isBooked, patientLogType, notes }) => {
          //   refetch();
          // }}
          // playingAudioRef={playingAudioRef}
          user={user}
          refetchLogs={() => {}}
          open={open}
          singleData={singleData[type]}
          // updateLogs={updateLogs}
          close={() => {
            setOpen(false);
          }}
        />
      )}

      <NoteItemMenu
        openDetails={() => setOpen(true)}
        logId={logId}
        callType={LogTypeMap[type]}
        isPinned={true}
        {...{ anchorEl, closeModal }}
      />
    </div>
  );
}
